module.exports = __webpack_public_path__ + "img/john-lewis.ddf79f42.png";